// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Montserrat-VariableFont_wght, BRLNSR, Arial, sans-serif,ClimateCrisis-Variable',
        fontSize: 14,
        body1: {
            //color: '#333',
        },
    },
    palette: {
        text: {
            primary: '#333',
        },
    },
    buttonProperties: {
        buttonborder: '#1c0a00',
        buttonradius: '45px',
        minWidth: '64px',
        buttonpadding: '9px 21px',
        texttransform: 'none',
        boxshadow: 'none',
        buttontextcolor: 'black',
        buttonHeight: '42px',
        buttonlineheight: '16px',
        buttondisplay: 'inline-flex',
        buttonalignitems: 'center',
        buttonFontWeight: '700',
        buttonFontFamily: 'Satoshi-Variable, sans-serif',
        btnBackground: 'white',
    },
});

export default theme;
